import React, { useState } from 'react';
export function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setEmail('');
    }
  };
  return <footer id="footer" className="bg-ink text-parchment pt-24 pb-12" data-id="element-145">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-146">
        {/* Massive Logo */}
        <div className="mb-20 border-b border-stone/20 pb-12" data-id="element-147">
          <div className="w-24 h-[1px] bg-copper mb-8 md:mx-0 mx-auto" data-id="element-148"></div>
          <h2 className="font-serif text-[12vw] leading-none font-light tracking-tight text-center md:text-left" data-id="element-149">
            The Makeup Atelier
          </h2>
          <p className="font-serif text-xl md:text-2xl font-light italic text-stone mt-6 text-center md:text-left" data-id="element-150">
            Beauty education, in person.
          </p>
        </div>

        {/* Editorial Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-24" data-id="element-151">
          <div data-id="element-152">
            <h4 className="font-sans text-xs uppercase tracking-[0.2em] text-stone mb-6" data-id="element-153">
              Navigation
            </h4>
            <ul className="space-y-4" data-id="element-154">
              <li data-id="element-155">
                <a href="#masterclasses" className="font-serif text-xl font-light hover:text-copper transition-colors" data-id="element-156">
                  Masterclasses
                </a>
              </li>
              <li data-id="element-157">
                <a href="#private" className="font-serif text-xl font-light hover:text-copper transition-colors" data-id="element-158">
                  Private Classes
                </a>
              </li>
              <li data-id="element-159">
                <a href="#services" className="font-serif text-xl font-light hover:text-copper transition-colors" data-id="element-160">
                  Makeup Services
                </a>
              </li>
              <li data-id="element-161">
                <a href="#founder" className="font-serif text-xl font-light hover:text-copper transition-colors" data-id="element-162">
                  About
                </a>
              </li>
              <li data-id="element-163">
                <a href="#faqs" className="font-serif text-xl font-light hover:text-copper transition-colors" data-id="element-164">
                  FAQs
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-165">
            <h4 className="font-sans text-xs uppercase tracking-[0.2em] text-stone mb-6" data-id="element-166">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-167">
              <li className="font-serif text-xl font-light" data-id="element-168">
                East Coast, Australia
              </li>
              <li className="font-serif text-xl font-light" data-id="element-169">
                Brisbane · Sydney · Melbourne
              </li>
              <li className="pt-2" data-id="element-170">
                <a href="mailto:hello@themakeupatelier.com.au" className="font-sans text-sm hover:text-copper transition-colors border-b border-transparent hover:border-copper pb-1" data-id="element-171">
                  hello@themakeupatelier.com.au
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-172">
            <h4 className="font-sans text-xs uppercase tracking-[0.2em] text-stone mb-6" data-id="element-173">
              Socials
            </h4>
            <ul className="space-y-4" data-id="element-174">
              <li data-id="element-175">
                <a href="#instagram" className="font-serif text-xl font-light hover:text-copper transition-colors" data-id="element-176">
                  Instagram
                </a>
              </li>
              <li data-id="element-177">
                <a href="#facebook" className="font-serif text-xl font-light hover:text-copper transition-colors" data-id="element-178">
                  Facebook
                </a>
              </li>
              <li data-id="element-179">
                <a href="#tiktok" className="font-serif text-xl font-light hover:text-copper transition-colors" data-id="element-180">
                  TikTok
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-181">
            <h4 className="font-sans text-xs uppercase tracking-[0.2em] text-stone mb-6" data-id="element-182">
              Newsletter
            </h4>
            <p className="font-serif text-xl font-light mb-6" data-id="element-183">
              Join our email list for first access to new classes and exclusive
              updates.
            </p>

            {isSubmitted ? <div className="flex items-center gap-3 text-copper py-2" data-id="element-184">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-185">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-186" />
                </svg>
                <span className="font-sans text-sm tracking-wide" data-id="element-187">
                  You're on the list.
                </span>
              </div> : <form onSubmit={handleSubscribe} className="relative flex items-end border-b border-stone/50 pb-2 focus-within:border-copper transition-colors duration-300" data-id="element-188">
                <label htmlFor="footer-email" className="sr-only" data-id="element-189">
                  Email Address
                </label>
                <input id="footer-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" required className="flex-1 bg-transparent border-none outline-none text-parchment placeholder-stone/50 font-sans text-sm px-0 py-1" data-id="element-190" />
                <button type="submit" className="text-stone hover:text-copper transition-colors px-2" aria-label="Subscribe" data-id="element-191">
                  &rarr;
                </button>
              </form>}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-stone/20" data-id="element-192">
          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-6" data-id="element-193">
            <p className="text-stone text-xs font-sans" data-id="element-194">
              &copy; {new Date().getFullYear()} The Makeup Atelier. All rights
              reserved.
            </p>
            <span className="hidden md:block text-stone/30" data-id="element-195">|</span>
            <p className="text-stone text-xs font-sans" data-id="element-196">ABN: 00 000 000 000</p>
          </div>
          <div className="flex gap-6" data-id="element-197">
            <a href="#" className="text-stone hover:text-copper transition-colors text-xs font-sans" data-id="element-198">
              Privacy Policy
            </a>
            <a href="#" className="text-stone hover:text-copper transition-colors text-xs font-sans" data-id="element-199">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}